// extracted by mini-css-extract-plugin
export default {"icon":"TJtun","more":"KSLK0","actions":"Q08mV","actionsTop":"St3PB"};